import { BadRequestException } from '../services/exceptions'
import { get, post } from './http'

// Get synopsis data
export async function getSynopsis() {
  // console.log('synopsisApi getSynopsis()')
  const response = await get(`/synopsis/get/`)
  if (response.status === 200)
    return await response.json()

  throw new BadRequestException((await response.json()).message)
}

// Revise synopsis data
export async function reviseSynopsis() {
  // console.log('synopsisApi reviseSynopsis()')
  const response = await post(`/synopsis/revise/`)
  console.log("reviseSynopsis response.status: ", response.statusText)

  if (response.status !== 200)
    throw new BadRequestException((await response.json()).message)
}
